import { AlertTriageIcon } from "../../Icons";
import { Typo } from "../../Typo";

type MarketingBannerErrorContentProps = {
  message: string;
  refreshLabel: string;
  onRefresh?: () => void;
};

export const MarketingBannerErrorContent = ({
  message,
  refreshLabel,
  onRefresh,
}: MarketingBannerErrorContentProps) => (
  <div
    className="flex flex-col items-center justify-center gap-6 py-4"
    data-testid="marketing-banner-error-state"
  >
    <AlertTriageIcon />
    <Typo
      type="bodyMD"
      textColor="text-text-secondary"
      className="max-w-[280px] text-center"
    >
      {message}
    </Typo>
    <button
      type="button"
      className="rounded-lg border border-stroke-secondary px-4 py-2 hover:bg-surface-tonal-default"
      onClick={onRefresh}
      data-testid="marketing-banner-refresh-button"
    >
      <Typo type="labelSM">{refreshLabel}</Typo>
    </button>
  </div>
);
